<template>

  <!-- 1st Hero Variation -->
  <section  class="section section_bg funnel_card funnel_page_card container-fluid h-100 first_page "
        >
    <loading-block v-if="is_load==false && is_load_error==false" :loading="!is_load"/>
    <div class="container-fluid" v-if="is_load==false && is_load_error==true">
      <div class="alert alert-warning">
        <h2>Ошибка</h2>
        <p>{{ load_error}}</p>
      </div>

    </div>
    <div class="section_header mobile_div d-flex justify-content-center" v-if="is_load">
      <nav aria-label="breadcrumb" v-if="is_load" >
        <ol class="breadcrumb">
           <li class="breadcrumb-item"><router-link tag="a" to="/leads" >Все сделки</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ funnel.title}}</li>
        </ol>
      </nav>
    </div>
    <div class="row" v-if="is_load">

      <div class=" col-lg-12">
        <div class="second_section">
          <h2> {{ funnel.title}}</h2>

            <ul class="nav justify-content-center mt-2 mb-2 widget_nav">
              <li class="nav-item" >
                <a class="nav-link" title="Канбан" :class="{'active':current_type_list=='canban'}" @click="changeTypeList('canban')"  href="javascript:void(0)"><i class="ni ni-button-pause"></i></a>
              </li>
              <li class="nav-item" >
                <a class="nav-link" title="Список" :class="{'active':current_type_list=='list'}" @click="changeTypeList('list')" ><i class="fa fa-list"></i></a>
              </li>

            </ul>

          <p v-if="$route.query && $route.query.q && $route.query.q.length>0">Поиск  по {{ $route.query.q }}</p>
          <vue-suggestion placeholder="Введите запрос для поиска" inputClasses="form-control" :items="items"
              v-model="item"
              :setLabel="setLabel"
              :itemTemplate="itemTemplate"
              @changed="inputChange"
              @selected="itemSelected">
          </vue-suggestion>
          <br>
          <div class="col-lg-12 m-4 d-flex justify-content-center">


             <router-link tag="a" class="btn" :to="{name: 'add_lead',params:{'id':funnel.last_id}}">
              Добавить сделку
            </router-link>
          </div>
        </div>

        <div class="row mt-2" v-if="stages.length>0">

          <kanban-board v-if="current_type_list=='canban'"    @update-block="updateBlock" :stages="stages" :blocks="blocks"> <div v-for="stage in stages" :slot="stage" :key="stage" >
            <h2>{{ stage }} <span class="badge badge-info">({{ statuses_count[stage]}})</span></h2>
          </div>

            <div class="section_gray_bg lead_mini" style="" v-for="block in blocks" :slot="block.id" :key="block.id" >

              <div class="card-body lead_info ">
                <div class="card-title" @click="openLead(block.id)" >#{{ block.lead.id }}</div>
                <div class="card-title" @click="openLead(block.id)"    v-if="block.lead.lead_data.name && block.lead.lead_data.name.length>0">{{ block.lead.lead_data.name}}</div>
                <div class="card-title" @click="openLead(block.id)" v-if="c_field.type=='email' && block.lead.lead_data[c_field.name]" v-for="c_field in custom_fields"><i class="color_black fa fa-address-book-o"></i>{{ block.lead.lead_data[c_field.name] }}</div>
                <div class="card-title" @click="openLead(block.id)" v-if="c_field.type=='phone' && block.lead.lead_data[c_field.name]" v-for="c_field in custom_fields"><i class="color_black fa fa-phone-square"></i>  {{ block.lead.lead_data[c_field.name] }}</div>

                <div class="card-text" @click="" v-if="block.lead.tags && block.lead.tags.length>0"
                ><b v-for="(tag,tag_index) in block.lead.tags" :key="tag_index">#<router-link tag="a" :to="{name: 'leads', query: { q: tag }}">
                  {{tag}}
                </router-link>&nbsp;</b></div
                >

                  <router-link tag="a" class="btn" :to="{name: 'lead',params:{id:block.lead.id}}">
                    Открыть
                  </router-link>


              </div>

            </div>
          </kanban-board>
          <div class="container mobile_div  testimonial-group mt-4 mb-4   " v-if="current_type_list=='list'">
          <div class="card mt-2 section_gray_bg lead_card"  v-if="leads.length>0 && is_load==true" v-for="(lead,lead_key) in leads">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="card-title">ID Лида:  #{{lead.id}}</h5>
                <h6 class="card-subtitle mb-2 text-muted">Дата добавления: {{ lead.created_at}}</h6>
                <h6 class="card-subtitle mb-2 text-muted">Дата обновления: {{ lead.updated_at}}</h6>
                <p class="card-text">Воронка:<router-link tag="a" :to="{name: 'funnel', params: { id: lead.funnel.last_id }}">
                  {{ lead.funnel.title}}
                </router-link></p>
                <p class="card-text">Статус: {{ lead.status.title }}</p>
                <p class="card-text"  v-if="lead.tags && lead.tags.length>0"
                >Теги:<b v-for="(tag,tag_index) in lead.tags" :key="tag_index">
                  #<router-link tag="a" :to="{name: 'leads', query: { q: tag }}">
                  {{tag}}
                </router-link>&nbsp;</b>
                </p>
              </div>

              <div class="col-sm-6">
                <h5 class="card-title">Информация о лиде:</h5>
                <p class="card-text" v-if=" lead.lead_data[c_field.name]" v-for="c_field in custom_fields"><i class="fa fa-phone-square " v-if="c_field.type=='phone'"></i> <i class="fa fa-vk" v-if="c_field.type=='vk'"></i> <i class="fa fa-address-book-o" v-if="c_field.type=='email'"></i> {{ c_field.title}}: <a v-if="c_field.type=='vk'" target="_blank" :href="lead.lead_data[c_field.name]" >{{ lead.lead_data[c_field.name] }}</a> <b v-if="c_field.type!='vk'">{{ lead.lead_data[c_field.name] }}</b></p>

                <router-link tag="a"  :to="{name: 'lead', params: { id: lead.id }}">
                  Открыть сделку
                </router-link>
              </div>
            </div>


          </div></div>

          <div class="col-12 col-sm-12 mt-5 ml-1  " v-if="total>offset">
            <div class="row second_section d-flex justify-content-center">
              <button class="btn" @click="loadMore">Загрузить еще</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";


import vueKanban from 'vue-kanban';
import itemTemplate from '@/components/itemTemplate.vue';
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "home",

  data() {

    var app = this;

    return {
      "is_load":false,
      'limit':100,
      'offset':0,
      'total':0,
      stages: [],
      current_funnel:null,
      custom_fields:[],
      statuses:[],
      funnel:null,
      blocks: [

      ],
      'current_type_list':"canban",
      is_load_error:false,
      load_error:'',
      "funnels": {},
      item: {},
      items: [

      ],
      'statuses_count':{

      },
      leads:[],
      itemTemplate,


    }
  },

  mounted: function () {

    var app=this;
    app.getTypeList();
    app.firstLoad();





  },
  methods: {
    changeTypeList(type){
      var app=this;
      localStorage.setItem("type_list_crm",type);
      app.current_type_list=type;
    },
    getTypeList(){
      var app=this;
      var result="canban";
      if(localStorage.getItem("type_list_crm")){
        result=localStorage.getItem("type_list_crm");
      }
      app.changeTypeList(result);
      return result;
    },
    addingLeads(leads){
      var app=this;
      if(leads && leads.length>0){



        leads.forEach((lead) => {
          if(!app.statuses_count.hasOwnProperty(lead.status.title)){
            app.statuses_count[lead.status.title]=0;
          }
          var new_arr={
            id: lead.id,
            status: lead.status.title,
            title: 'Лид '+lead.id,
            lead:lead,
          }
          app.statuses_count[lead.status.title]=app.statuses_count[lead.status.title]+1;
          app.blocks.push(new_arr);
        })
      }
    },
    loadMore(){
      var app = this;
      let id = app.$route.params.id;
      app.current_funnel=id;

      var q_string="";
      if(app.$route.query && app.$route.query.q && app.$route.query.q.length>0){
        q_string=app.$route.query.q;
      }
      Api.loadFunnel(id,app.limit,app.offset,q_string,function(data){
        app.is_load=true;
        app.funnel=data.funnel;
        app.custom_fields=data.custom_fields;
        app.leads=app.leads.concat(data.leads);
        app.offset=data.offset;
        app.total=data.total;
        app.addingLeads(data.leads);

      },function(err_message){
        app.is_load=false;
        app.is_load_error=true;
        app.load_error=err_message;
      })
    },
    firstLoad(){
      var app = this;
      let id = app.$route.params.id;
      app.current_funnel=id;

      var q_string="";
      if(app.$route.query && app.$route.query.q && app.$route.query.q.length>0){
        q_string=app.$route.query.q;
      }
      Api.loadFunnel(id,app.limit,app.offset,q_string,function(data){
        app.is_load=true;
        app.funnel=data.funnel;
        app.custom_fields=data.custom_fields;
        app.leads=app.leads.concat(data.leads);
        app.offset=data.offset;
        app.total=data.total;

        if(data.statuses.length>0){
          app.statuses=data.statuses;
          var statuses=data.statuses;
          statuses.forEach((element) => {
            var status_title=element.title;
            app.stages.push(status_title);
          })

          app.addingLeads(data.leads);

        }
      },function(err_message){
        app.is_load=false;
        app.is_load_error=true;
        app.load_error=err_message;
      })
    },
    callModelEditLead(lead){
      var app=this;
      var params = {
        "lead_id": lead.id,
        type: "editlead",
        modal_title: "Редактирование лида",
        json:lead.project_data
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    updateBlock(id, status) {
      var app=this;

      var statuses=app.statuses;
      var new_status=null;
      statuses.forEach((element) => {
        if(element.title==status){
          new_status=element;
        }

      })
      if(new_status!=null){
        var app=this;
        var lead_id=id;

        var  json={

          "status_id":new_status.last_id,

        }

        Api.updateLead(json,lead_id,function(data){

        },function(error){
          alert(error);
        });
      }

      //this.blocks.find(b => b.id === Number(id)).status = status;
    },
    openLead(lead_id){
      var app=this;
      app.$router.push({name: 'lead', params: {id: lead_id, "rand": Math.random()}});
    },
    itemSelected (item) {
      if(item.id=="query"){
        this.item = item;
        var app=this;
        //app.$router.push({name: 'lead', params: {id: item.id, "rand": Math.random()}});
         var current_route=app.$router.currentRoute;

         var new_route={};
         new_route['path']=current_route.path;
         new_route['query']={};
         new_route['query']['q']=item.q;


        app.$router.push(new_route);
      }else if(item.id=="query_total"){
        this.item = item;
        var app=this;
        //app.$router.push({name: 'lead', params: {id: item.id, "rand": Math.random()}});
        var current_route=app.$router.currentRoute;

        var new_route={};
        new_route['name']="leads";
        new_route['query']={};
        new_route['query']['q']=item.q;


        app.$router.push(new_route);
      }else {
        this.item = item;
        var app=this;
        app.$router.push({name: 'lead', params: {id: item.id, "rand": Math.random()}});
      }

    },
    setLabel (item) {
      return item.name;
    },
    inputChange (text) {
      var app=this;
      // your search method
      app.items=undefined;


      Api.searchLead(text,function(data){
        if(data.leads.length>0){
          app.items=[];
      var leads=data.leads;
          var new_elem_search={id:"query",name:" Поиск в воронке по запросу "+text,q:text};
          app.items.push(new_elem_search);
          var new_elem_search_total={id:"query_total",name:" Поиск по всем воронкам по запросу "+text,q:text};
          app.items.push(new_elem_search_total);

          leads.forEach((element) => {
            var name="";
            if(element.lead_data.name){
              name=name+" "+element.lead_data.name;
            }
            if(element.lead_data.phone){
              name=name+" "+element.lead_data.phone;
            }
            if(element.lead_data.email){
              name=name+" "+element.lead_data.email;
            }
            name=name+" "+element.funnel.title+"/"+element.status.title;
            var new_element={id:element.id,name:name};
            app.items.push(new_element);
          })

        }
      });
      // now `items` will be showed in the suggestion list
    },
    callModalAddLead() {

      var app=this;

      var params = {

        type: "addlead",
        islead: true,
        funnel_id:app.current_funnel,

        modal_title: "Добавление сделки",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Безымянный проект",
              "level": 2
            }
          }]
        }
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },


  },
  components: {Modal,LoadingBlock}
};
</script>
